import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEvents, useMixPanel } from '@/features/app/hooks'
import { authLogoutPA } from '@/features/auth/store'
import { TAG_MANAGER_EVENT } from '@/features/tag-manager/consts/event'
import { ROLE, useUser } from '@/features/user'
import { userData } from '@/features/user/store'
import { useAsyncDispatch, useNotify } from '@/hooks'

export const useLogout = () => {
  const { t } = useTranslation()

  const { loading, onAsyncDispatch } = useAsyncDispatch()
  const dispatch = useDispatch()
  const { showNotification } = useNotify()
  const { isBabysitter } = useUser()
  const mixPanel = useMixPanel()
  const event = useEvents()

  const logout = async () => {
    try {
      event.actions.generic(TAG_MANAGER_EVENT.LOGOUT)
      mixPanel.actions.reset()
      localStorage.removeItem('working-booking')
      const role = isBabysitter() ? ROLE.Babysitter : ROLE.Client

      await onAsyncDispatch(authLogoutPA.request)
      await dispatch(userData.setData({ role: role }))
      setTimeout(() => {
        window.location.reload()
      }, 100)
    } catch (error: any) {
      const message = error?.message || t('error')
      showNotification({ type: 'error', message: message })
    }
  }

  return {
    logout,
    loading,
  }
}
